import React, { Component } from 'react';
import {connect} from 'react-redux';
import LANGUAGE_CONTROLLER from '../../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';

const log = new Logger('BULK_REPLACE_TASK_LIST', LOG_LEVELS.DEBUG);

class TaskList extends Component {

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.state, { selectedIndex: [], hasFocus: false});
    }

    onChange(e) {
        const newSelectedIndex = [];
        for (let i = 0; i < e.target.options.length; ++i) {
            if (e.target.options[i].selected) {
                newSelectedIndex.push(i);
            }
        }
        this.setState({
            selectedIndex: newSelectedIndex
        });
        if(this.props.onChange) {
            this.props.onChange(e);
        }
    }

    onFocus(e) {
        this.setState({ hasFocus: true });
    }
 
    onBlur(e) {        
        this.setState({ hasFocus: false });
    }

    onRemove(e){
        if(this.props.onRemove) {
            this.props.onRemove({selectedIndex: this.state.selectedIndex});
        }
    }

    isEmpty() {
        return !(this.props.list && this.props.list.length > 0);
    }

    render() {
        log.debug('render: ', this.props);

        return (
            <s-row>
                <s-col span="8">
                    <label className="mt10"><LanguageStringResolver string="bulkFindReplace_taskList" /></label>                
                    <select multiple="true" style={{height: 'auto'}} onChange={(e) => {this.onChange(e)}} onFocus={(e) => {this.onFocus(e)}} onBlur={(e) => {this.onBlur(e)}}>
                        {
                            this.props.list.map((task, index) => {
                                const nodeLabel = LANGUAGE_CONTROLLER.format(this.props.languages, 'bulkFindReplace_node');
                                const replaceAllPhrase = LANGUAGE_CONTROLLER.format(this.props.languages, 'bulkFindReplace_replaceAllNodeValues');
                                const currentPart = task.replaceAllNodeValues
                                    ? `, ${replaceAllPhrase}`
                                    : (task.currentValue !== '' ? `, Current value = '${task.currentValue}'` : '');
                                return (
                                    <option key={index} value={index}>{nodeLabel} {task.node}{currentPart}{`, New value = '${task.newValue ? task.newValue : ''}'`}</option>
                                );
                            })
                        }
                    </select>
                    <div className="clear"></div>
                    <button className={this.state.hasFocus && !this.isEmpty() ? "secondary mt10" : "secondary mt10"} disabled={this.state.hasFocus && !this.isEmpty() ? "" : "disabled"} onMouseDown={(e) => this.onRemove(e)}><LanguageStringResolver string="bulkFindReplace_removeSelectedTask" /></button>
                </s-col>
            </s-row>
        );
    }
}

function mapStateToProps(state) {
    const stateProps = {
        languages: state.languages
    };
    return stateProps;
}

function mapDispatchToProps(dispatch) {

    const dispatchProps = {
    };
    return dispatchProps;

}


export default connect(mapStateToProps, mapDispatchToProps)(TaskList);
